// extracted by mini-css-extract-plugin
export default {"form":"SalesEditContainer_form__bvZsY"};